import styles from './style.postcss';
import MarkButtons from './MarkButtons/component';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  PaperbasedHomeworkStatusColorMappins,
  DefaultPaperbasedHomeworkStatus,
  validateHomeworkStatus,
} from 'data/PaperBasedHomework/status';
import { StudentCard } from 'omni-common-ui';
import { parseProductionStatus } from 'domain/ProductionStatus';

const Student = (props) => {
  const firstStatus = props.firstStatus || DefaultPaperbasedHomeworkStatus;
  const secondStatus = props.secondStatus || DefaultPaperbasedHomeworkStatus;
  const productionStatus = parseProductionStatus(props.productionStatus);
  const { isInProduction } = props;
  validateHomeworkStatus(firstStatus.toLowerCase());
  validateHomeworkStatus(secondStatus.toLowerCase());

  const renderHomeworkStatus = (homeworkStatus) => {
    switch (homeworkStatus) {
      case 'PartialComplete':
        return 'Partial Complete';
      case 'NotApplicable':
        return 'Not Applicable';
      default:
        return homeworkStatus;
    }
  };

  const renderMarkButtonOrStatus = (title, level, status, className) => {
    if (props.markable) {
      return <MarkButtons status={status}
          title={title}
          eventSender={level}
          className={className}
          canSeeNotApplicable={! isInProduction}
          onMarkComplete={props.onMarkComplete}
          onMarkIncomplete={props.onMarkIncomplete}
          onMarkPartialComplete={props.onMarkPartialComplete}
          onMarkNA={props.onMarkNA} />;
    }
    return <p className={classnames(styles.Student_homeworkStatusText, className)}>
      {renderHomeworkStatus(status)}
    </p>;
  };

  return <StudentCard withSeparatorLine={! props.markable}
      statusAccentColor={props.markable ? undefined : PaperbasedHomeworkStatusColorMappins[status]}>
    <StudentCard.Profile name={props.name}
        surname={props.surname}
        localName={props.localname}
        gender={props.gender}
        avatarUrl={props.avatarUrl}
        status={productionStatus.fullName}
        statusHighlighted={isInProduction} />
    <StudentCard.Content>
      {renderMarkButtonOrStatus(props.secondStatus ? 'Practice' : null, 'first', props.firstStatus)}
      { props.secondStatus ?
        renderMarkButtonOrStatus('Tutorial', 'second', props.secondStatus, styles.Student_hotPinkColor) :
        null }
    </StudentCard.Content>
  </StudentCard>;
};

Student.propTypes = {
  firstStatus: PropTypes.string,
  secondStatus: PropTypes.string,
  name: PropTypes.string,
  surname: PropTypes.string,
  localname: PropTypes.string,
  avatarUrl: PropTypes.string,
  gender: PropTypes.string,
  markable: PropTypes.bool,
  onMarkComplete: PropTypes.func,
  onMarkIncomplete: PropTypes.func,
  onMarkPartialComplete: PropTypes.func,
  onMarkNA: PropTypes.func,
  productionStatus: PropTypes.string,
  isInProduction: PropTypes.bool,
};

export default Student;



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkDayView/Student/student.jsx